var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        "close-on-click-modal": false,
        title: _vm.dialogTitle,
        visible: _vm.dialogVisible,
        width: "1000px",
        "append-to-body": true,
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
      },
    },
    [
      _c(
        "el-form",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          ref: "shop",
          attrs: {
            model: _vm.params,
            rules: _vm.paramsRules,
            "label-position": "top",
          },
        },
        [
          _c(
            "h6",
            { staticClass: "title" },
            [
              _vm._v(" " + _vm._s(_vm.$t("stores::store::shop_info")) + " "),
              _c(
                "el-tooltip",
                {
                  staticClass: "item",
                  attrs: {
                    content: _vm.shoplusInfo,
                    effect: "dark",
                    placement: "top-start",
                  },
                },
                [
                  _c("span", { staticClass: "tips pointer" }, [
                    _c("i", { staticClass: "icon-a-01wenhao iconfont-el" }),
                    _vm._v(
                      " " + _vm._s(_vm.$t("stores::store::how_bind")) + " "
                    ),
                  ]),
                ]
              ),
            ],
            1
          ),
          _c(
            "el-row",
            { attrs: { gutter: 24 } },
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("stores::store::shop_name"),
                        prop: "name",
                      },
                    },
                    [
                      _c("el-input", {
                        attrs: { disabled: _vm.$demo },
                        model: {
                          value: _vm.shopName,
                          callback: function ($$v) {
                            _vm.shopName =
                              typeof $$v === "string" ? $$v.trim() : $$v
                          },
                          expression: "shopName",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("stores::store::platform"),
                        prop: "mallType",
                      },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            disabled: _vm.isDetail,
                            placeholder: _vm.$t("system::common::input_holder"),
                            "popper-append-to-body": false,
                          },
                          model: {
                            value: _vm.params.mallType,
                            callback: function ($$v) {
                              _vm.$set(_vm.params, "mallType", $$v)
                            },
                            expression: "params.mallType",
                          },
                        },
                        [
                          _vm.isDetail
                            ? _c("el-option", {
                                attrs: { value: 1, label: "Shoplus" },
                              })
                            : _vm._e(),
                          _c("el-option", {
                            attrs: { value: 2, label: "Shopify" },
                          }),
                          _c("el-option", {
                            attrs: { value: 3, label: "Shoplazza" },
                          }),
                          _c("el-option", {
                            attrs: { value: 4, label: "Shopline" },
                          }),
                          _c("el-option", {
                            attrs: { value: 5, label: "Shopbase" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("stores::store::shop_domail"),
                        prop: "domain",
                      },
                    },
                    [
                      _c(
                        "el-input",
                        {
                          attrs: { disabled: _vm.isDetail },
                          model: {
                            value: _vm.params.domain,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.params,
                                "domain",
                                typeof $$v === "string" ? $$v.trim() : $$v
                              )
                            },
                            expression: "params.domain",
                          },
                        },
                        [
                          _c("template", { slot: "prepend" }, [
                            _c("div", [_vm._v("https://")]),
                          ]),
                          _vm.params.mallType !== 1
                            ? _c("template", { slot: "append" }, [
                                _vm.params.mallType === 2
                                  ? _c("span", [_vm._v(".myshopify.com")])
                                  : _vm._e(),
                                _vm.params.mallType === 3
                                  ? _c("span", [_vm._v(".myshoplaza.com")])
                                  : _vm._e(),
                                _vm.params.mallType === 4
                                  ? _c("span", [_vm._v(".myshopline.cn")])
                                  : _vm._e(),
                                _vm.params.mallType === 5
                                  ? _c("span", [_vm._v(".onshopbase.com")])
                                  : _vm._e(),
                              ])
                            : _vm._e(),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("stores::store::ind_domail"),
                        prop: "independDomain",
                      },
                    },
                    [
                      _c("el-input", {
                        attrs: { disabled: _vm.$demo },
                        model: {
                          value: _vm.params.independDomain,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.params,
                              "independDomain",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "params.independDomain",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("stores::store::category"),
                        prop: "shopCategoryId",
                      },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            placeholder: _vm.$t("system::common::input_holder"),
                            "popper-append-to-body": false,
                            disabled: _vm.$demo,
                          },
                          model: {
                            value: _vm.params.shopCategoryId,
                            callback: function ($$v) {
                              _vm.$set(_vm.params, "shopCategoryId", $$v)
                            },
                            expression: "params.shopCategoryId",
                          },
                        },
                        _vm._l(_vm.typeOptions, function (item) {
                          return _c("el-option", {
                            key: item.dictItemValue,
                            attrs: {
                              label: item.dictItemKey,
                              value: item.dictItemValue,
                            },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { prop: "status" } },
                    [
                      _c(
                        "div",
                        {
                          staticStyle: { display: "inline-block" },
                          attrs: { slot: "label" },
                          slot: "label",
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(_vm.$t("stores::store::shop_status")) +
                              " "
                          ),
                          _c(
                            "el-tooltip",
                            {
                              staticClass: "item",
                              attrs: { effect: "dark", placement: "bottom" },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticStyle: { width: "132px" },
                                  attrs: { slot: "content" },
                                  slot: "content",
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("stores::store::open_close"))
                                  ),
                                ]
                              ),
                              _c("i", {
                                staticClass: "icon-a-01wenhao iconfont-el",
                              }),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-radio-group",
                        {
                          attrs: { disabled: _vm.$demo },
                          model: {
                            value: _vm.params.status,
                            callback: function ($$v) {
                              _vm.$set(_vm.params, "status", $$v)
                            },
                            expression: "params.status",
                          },
                        },
                        [
                          _c("el-radio", { attrs: { label: 1 } }, [
                            _vm._v(_vm._s(_vm.$t("stores::store::shop_open"))),
                          ]),
                          _c("el-radio", { attrs: { label: 0 } }, [
                            _vm._v(_vm._s(_vm.$t("stores::store::shop_close"))),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "certification" },
            [
              _c(
                "h6",
                { staticClass: "title" },
                [
                  _vm._v(
                    " " + _vm._s(_vm.$t("stores::store::authentication")) + " "
                  ),
                  _c(
                    "el-tooltip",
                    { attrs: { effect: "dark", placement: "bottom" } },
                    [
                      _c(
                        "div",
                        {
                          staticStyle: { width: "200px" },
                          attrs: { slot: "content" },
                          slot: "content",
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("stores::store::authentication_info"))
                          ),
                        ]
                      ),
                      _c("i", { staticClass: "icon-a-01wenhao iconfont-el" }),
                    ]
                  ),
                  _c(
                    "span",
                    {
                      staticClass: "title-tip",
                      on: {
                        click: function ($event) {
                          _vm.showGuiderDialog = true
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("stores::store::guide")))]
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                { attrs: { gutter: 24 } },
                [
                  _vm.params.mallType === 1 || _vm.params.mallType === 2
                    ? _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "API Key", prop: "appKey" } },
                            [
                              _vm.params.mallType === 1
                                ? _c("el-input", {
                                    attrs: {
                                      disabled: _vm.$demo,
                                      placeholder: _vm.$t(
                                        "stores::store::holder::shoplus_api_key"
                                      ),
                                    },
                                    model: {
                                      value: _vm.params.appKey,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.params,
                                          "appKey",
                                          typeof $$v === "string"
                                            ? $$v.trim()
                                            : $$v
                                        )
                                      },
                                      expression: "params.appKey",
                                    },
                                  })
                                : _vm._e(),
                              _vm.params.mallType === 2
                                ? _c("el-input", {
                                    attrs: {
                                      placeholder: _vm.$t(
                                        "stores::store::holder::shopify_api_key"
                                      ),
                                      disabled: _vm.$demo,
                                    },
                                    model: {
                                      value: _vm.params.appKey,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.params,
                                          "appKey",
                                          typeof $$v === "string"
                                            ? $$v.trim()
                                            : $$v
                                        )
                                      },
                                      expression: "params.appKey",
                                    },
                                  })
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.params.mallType === 1 || _vm.params.mallType === 2
                    ? _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("stores::store::api_password"),
                                prop: "appSecret",
                              },
                            },
                            [
                              _vm.params.mallType === 1
                                ? _c("el-input", {
                                    attrs: {
                                      placeholder: _vm.$t(
                                        "stores::store::holder::shoplus_api_password"
                                      ),
                                      disabled: _vm.$demo,
                                    },
                                    model: {
                                      value: _vm.params.appSecret,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.params,
                                          "appSecret",
                                          typeof $$v === "string"
                                            ? $$v.trim()
                                            : $$v
                                        )
                                      },
                                      expression: "params.appSecret",
                                    },
                                  })
                                : _vm._e(),
                              _vm.params.mallType === 2
                                ? _c("el-input", {
                                    attrs: {
                                      placeholder: _vm.$t(
                                        "stores::store::holder::shopify_api_password"
                                      ),
                                      disabled: _vm.$demo,
                                    },
                                    model: {
                                      value: _vm.params.appSecret,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.params,
                                          "appSecret",
                                          typeof $$v === "string"
                                            ? $$v.trim()
                                            : $$v
                                        )
                                      },
                                      expression: "params.appSecret",
                                    },
                                  })
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.params.mallType === 3
                    ? [
                        _c(
                          "el-col",
                          { attrs: { span: 12 } },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "API Token", prop: "token" } },
                              [
                                _c("el-input", {
                                  attrs: {
                                    disabled: _vm.$demo,
                                    placeholder: _vm.$t(
                                      "stores::store::holder::api_token"
                                    ),
                                  },
                                  model: {
                                    value: _vm.params.token,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.params, "token", $$v)
                                    },
                                    expression: "params.token",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 12 } },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "API UID", prop: "appKey" } },
                              [
                                _c("el-input", {
                                  attrs: {
                                    disabled: _vm.$demo,
                                    placeholder: _vm.$t(
                                      "stores::store::holder::api_uid"
                                    ),
                                  },
                                  model: {
                                    value: _vm.params.appKey,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.params, "appKey", $$v)
                                    },
                                    expression: "params.appKey",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 12 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "API Secret",
                                  prop: "appSecret",
                                },
                              },
                              [
                                _c("el-input", {
                                  attrs: {
                                    disabled: _vm.$demo,
                                    placeholder: _vm.$t(
                                      "stores::store::holder::api_secret"
                                    ),
                                  },
                                  model: {
                                    value: _vm.params.appSecret,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.params, "appSecret", $$v)
                                    },
                                    expression: "params.appSecret",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]
                    : _vm._e(),
                  _vm.params.mallType === 4
                    ? [
                        _c(
                          "el-col",
                          { attrs: { span: 12 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "Shopline Token",
                                  "label-width": "130px",
                                  prop: "token",
                                },
                              },
                              [
                                _c("el-input", {
                                  attrs: {
                                    disabled: _vm.$demo,
                                    placeholder: _vm.$t(
                                      "stores::store::holder::shopline_token"
                                    ),
                                  },
                                  model: {
                                    value: _vm.params.token,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.params, "token", $$v)
                                    },
                                    expression: "params.token",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]
                    : _vm._e(),
                  _vm.params.mallType === 5
                    ? [
                        _c(
                          "el-col",
                          { attrs: { span: 12 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.$t(
                                    "stores::store::label::shopbase_api_key"
                                  ),
                                  prop: "appKey",
                                },
                              },
                              [
                                _c("el-input", {
                                  attrs: {
                                    disabled: _vm.$demo,
                                    placeholder: _vm.$t(
                                      "stores::store::holder::shopbase_api_key"
                                    ),
                                  },
                                  model: {
                                    value: _vm.params.appKey,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.params,
                                        "appKey",
                                        typeof $$v === "string"
                                          ? $$v.trim()
                                          : $$v
                                      )
                                    },
                                    expression: "params.appKey",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 12 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.$t(
                                    "stores::store::label::shopbase_api_secret"
                                  ),
                                  prop: "appSecret",
                                },
                              },
                              [
                                _c("el-input", {
                                  attrs: {
                                    disabled: _vm.$demo,
                                    placeholder: _vm.$t(
                                      "stores::store::holder::shopbase_api_secret"
                                    ),
                                  },
                                  model: {
                                    value: _vm.params.appSecret,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.params,
                                        "appSecret",
                                        typeof $$v === "string"
                                          ? $$v.trim()
                                          : $$v
                                      )
                                    },
                                    expression: "params.appSecret",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 12 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.$t(
                                    "stores::store::label::shopbase_webhook"
                                  ),
                                  prop: "webhookSecret",
                                },
                              },
                              [
                                _c("el-input", {
                                  attrs: {
                                    disabled: _vm.$demo,
                                    placeholder: _vm.$t(
                                      "stores::store::holder::shopbase_webhook"
                                    ),
                                  },
                                  model: {
                                    value: _vm.params.webhookSecret,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.params,
                                        "webhookSecret",
                                        typeof $$v === "string"
                                          ? $$v.trim()
                                          : $$v
                                      )
                                    },
                                    expression: "params.webhookSecret",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]
                    : _vm._e(),
                  _vm.params.mallType === 2
                    ? _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "Webhook",
                                prop: "webhookSecret",
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  placeholder: _vm.$t(
                                    "stores::store::holder::shopify_webhook"
                                  ),
                                  disabled: _vm.$demo,
                                },
                                model: {
                                  value: _vm.params.webhookSecret,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.params,
                                      "webhookSecret",
                                      typeof $$v === "string" ? $$v.trim() : $$v
                                    )
                                  },
                                  expression: "params.webhookSecret",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                2
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "span",
        {
          staticClass: "footer_class",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            {
              on: {
                click: function ($event) {
                  _vm.dialogVisible = false
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("system::common::btn::cancel")))]
          ),
          _c(
            "el-button",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.isDetail && !_vm.isNew,
                  expression: "isDetail && !isNew",
                },
              ],
              attrs: { loading: _vm.isLoding, type: "primary" },
              on: { click: _vm.submitConfirm },
            },
            [_vm._v(" " + _vm._s(_vm.$t("system::common::btn::confirm")) + " ")]
          ),
          _c(
            "el-button",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.isDetail && _vm.isNew,
                  expression: "!isDetail && isNew",
                },
              ],
              attrs: { loading: _vm.isLoding, type: "primary" },
              on: { click: _vm.saveSuccess },
            },
            [_vm._v(" " + _vm._s(_vm.$t("system::common::btn::confirm")) + " ")]
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          staticStyle: { "margin-top": "20vh" },
          attrs: {
            title: _vm.$t("stores::store::sync_tips"),
            visible: _vm.isSyncShow,
            "append-to-body": "",
            width: "400px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.isSyncShow = $event
            },
          },
        },
        [
          _vm._v(" " + _vm._s(_vm.$t("stores::store::sync_again")) + " "),
          _c(
            "span",
            {
              staticClass: "footer_class",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.saveSuccess } }, [
                _vm._v(_vm._s(_vm.$t("stores::store::no_sync"))),
              ]),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.saveAndAsync } },
                [_vm._v(_vm._s(_vm.$t("stores::store::save_sync")))]
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "el-dialog",
        {
          staticClass: "auth-guide",
          attrs: {
            title: _vm.$t("stores::store::guide"),
            visible: _vm.showGuiderDialog,
            "append-to-body": "",
            width: "500px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.showGuiderDialog = $event
            },
          },
        },
        [
          _c(
            "el-collapse",
            {
              attrs: { accordion: "" },
              model: {
                value: _vm.collapseName,
                callback: function ($$v) {
                  _vm.collapseName = $$v
                },
                expression: "collapseName",
              },
            },
            [
              _c(
                "el-collapse-item",
                {
                  attrs: {
                    title: _vm.$t("stores::store::shop_guide", {
                      mallType: "shopify",
                    }),
                    name: "1",
                  },
                },
                [_c("authGuider", { attrs: { shop: _vm.stepList[2] } })],
                1
              ),
              _c(
                "el-collapse-item",
                {
                  attrs: {
                    title: _vm.$t("stores::store::shop_guide", {
                      mallType: "shopplazza",
                    }),
                    name: "2",
                  },
                },
                [_c("authGuider", { attrs: { shop: _vm.stepList[3] } })],
                1
              ),
              _c(
                "el-collapse-item",
                {
                  attrs: {
                    title: _vm.$t("stores::store::shop_guide", {
                      mallType: "shopline",
                    }),
                    name: "3",
                  },
                },
                [_c("authGuider", { attrs: { shop: _vm.stepList[4] } })],
                1
              ),
              _c(
                "el-collapse-item",
                {
                  attrs: {
                    title: _vm.$t("stores::store::shop_guide", {
                      mallType: "shopbase",
                    }),
                    name: "4",
                  },
                },
                [_c("authGuider", { attrs: { shop: _vm.stepList[5] } })],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }